export enum BombType {
    A,B
}